module.exports = __webpack_public_path__ + "media/images/icons/twotone/medicine-box-9563c256d4dc92d72e22fe0a78d6e971.svg";